var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingsLastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45 3.58621L0 13L4.65 7.47126L8.55 9.41379L12 0L7.8 5.22989L3.45 3.58621Z",
    fill: "#AE2B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingsLastIcon);
export default __webpack_public_path__ + "static/media/savings_last_icon.ee52fec9f8c2162d9cbdcf58e9827137.svg";
export { ForwardRef as ReactComponent };